import { usePeriod } from '@/app/context/PeriodContext';
import { useGetActiveBuildingsQuery } from '@/app/services/buildingsApi';
import {
  useDeleteAccountingExpensesMutation,
  useFindAccountingExpensesByPeriodAndBuildingQuery,
} from '@/app/services/IncomingAccountingExpeseApi';
import ConfigureExpenseTable from '@/components/Configureexpense/ExpenseTable';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import { MenuItem, Select } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

function ConfigureExpenses() {
  const { t } = useTranslation(['configureExpense', 'common']);
  const { selectedPeriod, setSelectedPeriod } = usePeriod();
  const [selectedBuilding, setSelectedBuilding] = useState(1);
  const { data: buildings } = useGetActiveBuildingsQuery();
  const { data: configureExpenses } = useFindAccountingExpensesByPeriodAndBuildingQuery({
    period: selectedPeriod?.date,
    buildingId: selectedBuilding,
  });

  const [deleteConfigureExpenses] = useDeleteAccountingExpensesMutation();

  const handleDelete = async (id: number) => {
    const response = await deleteConfigureExpenses(id);

    if ('data' in response) {
      toast.success(
        t('expense.deleted.successfully', {
          position: toast.POSITION.TOP_RIGHT,
        }),
      );
    }
  };

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem' }}>
        <Typography variant="h1">{t('common:configure.expenses')}</Typography>
        <Typography sx={{ marginLeft: '0.5rem' }}>{`(${t('common:by.building')})`}</Typography>
      </div>
      <Typography>{t('by.configuring.expense.subtitle')}</Typography>

      <div style={{ width: '100%', marginTop: '24px', marginBottom: '16px', alignItems: 'center' }}>
        <Typography variant="h2">{t('common:building')}</Typography>
        <Select
          size="small"
          sx={{ width: '25%' }}
          value={selectedBuilding}
          onChange={(e) => setSelectedBuilding(e.target.value as number)}
          renderValue={(selected) => buildings?.find((item) => item.id === selected)?.name}
        >
          {buildings?.map((building) => (
            <MenuItem key={building.name} value={building.id}>
              {building.name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <ConfigureExpenseTable expenses={configureExpenses || []} handleDelete={handleDelete} />
    </div>
  );
}
export default ConfigureExpenses;
